import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchIngresosBySocio } from '../actions/ingresoActions'; 
import { Modal, Button } from 'react-bootstrap';
import ReciboModal from './ReciboModal';
import './GestionRecibos.css';

const GestionRecibos = ({ showGestionRecibosModal, closeGestionRecibosModal, socio }) => {
  const dispatch = useDispatch();
  const { ingresos, loading, error } = useSelector(state => state.ingreso);
  const [showReciboModal, setShowReciboModal] = useState(false);
  const [reciboData, setReciboData] = useState({
    nroRecibo: '',
    fechaPago: new Date(),
    beneficiario: '',
    concepto: '',
    detalles: [],
    total: 0
  });

  useEffect(() => {
    if (showGestionRecibosModal && socio && socio.id) {
      dispatch(fetchIngresosBySocio(socio.id));
    }
  }, [dispatch, socio, showGestionRecibosModal]);

  const handleOpenReciboModal = (ingreso) => {
    setReciboData({
      nroRecibo: ingreso.nrorec,
      fechaPago: new Date(ingreso.fecha),
      beneficiario: ingreso.beneficiario,
      concepto: ingreso.concepto,
      detalles: ingreso.detalles || [],
      total: ingreso.monto
    });
    setShowReciboModal(true);
  };

  if (loading) return (
    <Modal show={showGestionRecibosModal} onHide={closeGestionRecibosModal}>
      <Modal.Body>Cargando ingresos...</Modal.Body>
    </Modal>
  );

  if (error) return (
    <Modal show={showGestionRecibosModal} onHide={closeGestionRecibosModal}>
      <Modal.Body>Error: {error}</Modal.Body>
    </Modal>
  );

  return (
    <>
      <Modal 
        show={showGestionRecibosModal} 
        onHide={closeGestionRecibosModal} 
        size="lg" 
        backdrop="static" 
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Ingresos del Socio</Modal.Title>
          <p className="mb-0">{`${socio.nombres} ${socio.apPat} ${socio.apMat} (${socio.codreg})`}</p>
        </Modal.Header>
        <Modal.Body>
          <div className="ingresos-list">
            {ingresos && ingresos.length > 0 ? (
              ingresos.sort((a, b) => b.nrorec - a.nrorec).map(ingreso => (
                <div key={ingreso.nrorec} className="ingreso-item mb-3 p-3 border rounded">
                  <div className="d-flex justify-content-between">
                    <div>
                      <strong>N°: {ingreso.nrorec}</strong>
                      <div>Fecha: {new Date(ingreso.fecha).toLocaleDateString()}</div>
                      <div>Concepto: {ingreso.concepto}</div>
                    </div>
                    <div className="text-end">
                      <div className="fs-5">${Number(ingreso.monto).toFixed(2)}</div>
                      <Button 
                        variant="primary" 
                        size="sm" 
                        onClick={() => handleOpenReciboModal(ingreso)}
                      >
                        Imprimir Recibo
                      </Button>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="text-center py-4">
                <p>No se encontraron ingresos para este socio</p>
              </div>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={closeGestionRecibosModal}>
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>

      <ReciboModal
        show={showReciboModal}
        handleClose={() => setShowReciboModal(false)}
        nroRecibo={reciboData.nroRecibo}
        data={reciboData}
      />
    </>
  );
};

export default GestionRecibos;